module.exports = __webpack_public_path__ + "assets/20ed5ea91b0cb8e1adeaa5056822ef6d.svg";